export default __webpack_public_path__ + "static/media/blue-prince-2.b16d8c66.webp";